import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { ForensicMotif } from './ui/ForensicMotif';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="relative isolate overflow-hidden bg-navy py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-156" data-mp="2vqhdy5hjvfwp">
      <ForensicMotif side="left" data-id="element-157" data-mp="39hcrhv2zul6m" />
      <div className="mx-auto max-w-4xl px-4" data-id="element-158" data-mp="39gb4qtcm8a92">
        <div className="text-center" data-id="element-159" data-mp="35gkjf55uymbx">
          <SectionHeading id="problem-title" data-id="element-160" data-mp="35fiv3yzu03c9">Ti suona <span className="text-gold" data-id="element-161" data-mp="35in5je3w3vbd">familiare?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-ivory/80" data-id="element-162" data-mp="3jfjxjivqvitu">
            Le scienze forensi appassionano gli studenti, ma trasformarle in lezioni serie, chiare e ben organizzate richiede
            tempo. Metodo scientifico, prove, impronte, DNA e catena di custodia sono concetti che vanno spiegati con rigore, e
            tu devi farlo senza materiali adeguati.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-gold/30 bg-navy-light/70 p-6 shadow-lg shadow-black/30 sm:p-8" data-id="element-163" data-mp="jb0qjk0d5id7">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-extrabold uppercase text-ivory" data-id="element-164" data-mp="122jrzmeqood4">
            <AlertTriangleIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-165" data-mp="171efh1nnj13k" />
            Il vero problema:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-166" data-mp="1bzocziwumdsc">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-ivory/80" data-id="element-167" data-mp="1g22yybvtdtnu">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-gold" aria-hidden="true" data-id="element-168" data-mp="3du749fg299gf" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-169" data-mp="ozh44ctj74mo">
          <p className="mx-auto max-w-2xl text-lg font-bold text-ivory" data-id="element-170" data-mp="p0irngrqhjla">
            Non ti servono altre informazioni sparse.
          </p>
          <p className="mt-3 text-2xl font-extrabold uppercase tracking-tight text-gold sm:text-3xl" data-id="element-171" data-mp="y0oywkwu9nc0">Ti serve un sistema organizzato e pronto per la classe.</p>
        </div>
      </div>
    </section>;
}